// extracted by mini-css-extract-plugin
export default {"imgBox":"Profile_imgBox__7bTjZ","img":"Profile_img__4RlJR","list":"Profile_list__LJcHc","line":"Profile_line__bQxQj","phone":"Profile_phone__-ajjs"};